import { useCallback } from 'react';
import ModalComponent from 'src/components/Modal/ModalComponent';
import { useUserContext } from 'src/contexts/UserContext';
import { OrdersService } from 'src/services/Orders';
import { translateErrorMessages } from '../../utils';

const ApproveModal = ({
  closeModal,
  fetchOrderDetail,
  orderNumber,
  orderUUID,
}) => {
  const { showToast, sendEvent, accessToken } = useUserContext();

  const acceptOrderStatus = useCallback(async () => {
    try {
      await OrdersService.confirmNewOrder({
        uuid: orderUUID,
        accessToken,
      });
      showToast(`Pedido ${orderNumber} Atualizado`, 'success');

      fetchOrderDetail();
    } catch (error) {
      const message = translateErrorMessages(error, orderNumber);
      showToast(message, 'error');
    } finally {
      window.scroll(0, 0);
      closeModal();
    }
  }, [sendEvent, showToast]);

  return (
    <ModalComponent title="Confirmação de Pedido" closeModal={closeModal}>
      <p className="card-text pb-3">
        Você confirma estar preparado para aceitar o <br /> pedido e realizar a
        entrega dentro do prazo estipulado?
      </p>
      <button href="#" className="btn btn-confirm" onClick={acceptOrderStatus}>
        Confirmar
      </button>
    </ModalComponent>
  );
};

export default ApproveModal;
